/* eslint-disable */
import * as actions from './action'
import mutations from './mutation'
const review = {
  state: {
    reviewList: []
  },
  mutations: {
    ...mutations
  },
  actions: {
    ...actions
  }
}

export default review



// WEBPACK FOOTER //
// ./src/store/modules/review/index.js